import Axios from "axios";
import React, { Component } from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    NavLink,
    useParams,
    useRouteMatch,
    useHistory,
    Redirect,
} from "react-router-dom";
import { useTranslation, withTranslation } from "react-i18next";
import { QRCode } from "react-qrcode-logo";
import hoistStatics from "hoist-non-react-statics";
import Func from "../../functions";
import Loading from "../../layouts/Loading";
import Env from "../../env";

class GrabMix extends Component {
    constructor(props) {
        super(props);
        this.state = {
            qrCodeId: Date.now().toString(),
        };
    }

    componentDidMount = async () => {
        this.props.i18n.changeLanguage(this.props.lngName);
    };

    setLoading = (v) => {
        this.setState({ isLoading: v });
    };

    copyClick = (element) => {
        $("#" + element).trigger("click");
    };

    render() {
        let showPostScriptStyle = this.props.styles.displayNormal;
        if (!this.props.data.detail.postscript) {
            showPostScriptStyle = this.props.styles.displayNone;
        }
        let showPayerNameStyle = this.props.styles.displayNormal;
        if (!this.props.data.payerName) {
            showPayerNameStyle = this.props.styles.displayNone;
        }

        let inputEndRadius = this.props.styles.inputEndRadius;

        let grabMixStyle = {
            tagLabel: {
                color: "#fff",
            },
            tagBtnMemoBgColor: {
                background: "#fff",
            },
            tagContentTextShadow: {
                textShadow: "#dc3545 0px 0px 0px",
            },
        };

        return (
            <div>
                <div className="form-group row" style={showPayerNameStyle}>
                    <label
                        className="col-sm-12 col-form-label text-sm"
                        style={grabMixStyle.tagLabel}
                    >
                        {this.props.t("Cashier.PayerName")}
                    </label>
                    <div
                        className="col-sm-12"
                        style={this.props.styles.rowMarginBottom}
                    >
                        <input
                            id="payerName"
                            name="payerName"
                            className="form-control form-control-sm"
                            style={this.props.styles.inputReadOnlyStyle}
                            value={this.props.payerName}
                            readOnly
                        />
                        <div
                            className="input-group text-danger text-xs"
                            style={grabMixStyle.tagContentTextShadow}
                        >
                            {this.props.t("Cashier.GrabPayerContent")}
                        </div>
                    </div>
                </div>
                <div className="form-group row" style={showPostScriptStyle}>
                    <label
                        className="col-sm-12 col-form-label text-sm"
                        style={grabMixStyle.tagLabel}
                    >
                        {this.props.t("Cashier.Postscript")}
                    </label>
                    <div
                        className="input-group col-sm-12"
                        style={this.props.styles.rowMarginBottom}
                    >
                        <input
                            id="postscript"
                            name="postscript"
                            className="form-control form-control-sm"
                            style={this.props.styles.inputReadOnlyStyle}
                            value={this.props.data.detail.postscript}
                            onClick={(e) => this.props.copyData(e)}
                            readOnly
                        />
                        <div
                            className="input-group-append"
                            style={grabMixStyle.tagBtnMemoBgColor}
                        >
                            <div
                                className="input-group-text text-xs"
                                style={inputEndRadius}
                                onClick={() => this.copyClick("postscript")}
                            >
                                <span className="fas text-xs">Copy</span>
                            </div>
                        </div>
                        <div
                            className="input-group text-danger text-xs"
                            style={grabMixStyle.tagContentTextShadow}
                        >
                            {this.props.t("Cashier.PostscriptContent")}
                        </div>
                    </div>
                </div>
                <div
                    className="form-group row"
                    style={this.props.styles.rowMarginBottom}
                >
                    <label
                        className="col-sm-12 col-form-label text-sm"
                        style={grabMixStyle.tagLabel}
                    >
                        {this.props.t("Cashier.Amount")}
                    </label>
                    <div
                        className="input-group col-sm-12"
                        style={this.props.styles.rowMarginBottom}
                    >
                        <input
                            id="amount"
                            name="amount"
                            className="form-control form-control-sm"
                            style={this.props.styles.inputReadOnlyStyle}
                            value={this.props.data.amount}
                            onClick={(e) => this.props.copyData(e)}
                            readOnly
                        />
                        <div
                            className="input-group-append"
                            style={grabMixStyle.tagBtnMemoBgColor}
                        >
                            <div
                                className="input-group-text text-xs"
                                style={inputEndRadius}
                                onClick={() => this.copyClick("amount")}
                            >
                                <span className="fas text-xs">Copy</span>
                            </div>
                        </div>
                        <div
                            className="input-group text-danger text-xs"
                            style={grabMixStyle.tagContentTextShadow}
                        >
                            {this.props.t("Cashier.AmountContent1")}
                            <br />
                            {this.props.t("Cashier.AmountContent2")}
                        </div>
                    </div>
                </div>
                <div
                    className="form-group row"
                    style={this.props.styles.rowMarginBottom}
                >
                    <label
                        className="col-sm-12 col-form-label text-sm"
                        style={grabMixStyle.tagLabel}
                    >
                        {this.props.t("Cashier.ReceiveGCashAccount")}
                    </label>
                    <div
                        className="input-group col-sm-12"
                        style={this.props.styles.rowMarginBottom}
                    >
                        <input
                            id="card_no"
                            name="card_no"
                            className="form-control form-control-sm"
                            style={this.props.styles.inputReadOnlyStyle}
                            value={this.props.data.detail.phone_number}
                            onClick={(e) => this.props.copyData(e)}
                            readOnly
                        />
                        <div
                            className="input-group-append"
                            style={grabMixStyle.tagBtnMemoBgColor}
                        >
                            <div
                                className="input-group-text text-xs"
                                style={inputEndRadius}
                                onClick={() => this.copyClick("card_no")}
                            >
                                <span className="fas text-xs">Copy</span>
                            </div>
                        </div>
                        <div
                            className="input-group text-danger text-xs"
                            style={grabMixStyle.tagContentTextShadow}
                        >
                            {this.props.t("Cashier.CardNumberContent")}
                        </div>
                    </div>
                </div>
                {Env.showQrCode == "Y" &&
                this.props.data.detail.mark_code &&
                this.props.data.detail.mark_code != "" ? (
                    <div
                        className="form-group row"
                        style={this.props.styles.rowMarginBottom}
                    >
                        <label
                            className="col-sm-12 col-form-label text-sm"
                            style={grabMixStyle.tagLabel}
                        >
                            {this.props.t("Cashier.QrCode")}
                        </label>
                        <div
                            id={"qr_" + this.state.qrCodeId + "_code_f"}
                            className="input-group col-sm-12"
                            style={this.props.styles.rowMarginBottomQrCode}
                        >
                            <QRCode
                                id={"qr_" + this.state.qrCodeId + "_code"}
                                value={this.props.data.detail.mark_code}
                                ecLevel="H"
                                size={
                                    $("#main_layout_card").width() * (70 / 100)
                                }
                                logoImage="/images/grab/grab-logo.png"
                                // qrStyle={this.props.styles.qrCode}
                            />
                            {/* <img
                                src={this.props.data.detail.qrcode}
                                style={this.props.styles.qrCode}
                            /> */}
                        </div>
                    </div>
                ) : (
                    ""
                )}
            </div>
        );
    }
}

export default hoistStatics(withTranslation()(GrabMix), GrabMix);
